import "../style.css";
import React from 'react';
import PanelContent from "../components/PanelContent"

export default function SmartPowering() {
  return (
    <PanelContent 
        id="powering_pannel"
        route="/smartpowering"
        title="Alimentation électrique dynamique"
        subtitle="Gestion de l'énergie selon la position du véhicule"
        description="La deuxième étape de ce test consiste à alimenter la piste ERS. Celle-ci est en effet divisée en sections de 11 mètres, qui s'activent grâce à la communication entre le camion et la piste. Les sections ne s'activent que lorsque le véhicule les traverse, tandis que les autres demeurent inactives. Le résultat ? Une consommation optimisée tout en assurant la sécurité."
        prev="/energyflow"
        next="/captation"
        txtbtn="ÉTAPE SUIVANTE"
    />
  );
}
